import { render } from "./Error.vue?vue&type=template&id=1e0f7dcc"
const script = {}
script.render = render

export default script